import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationLicenseActivationDelete = {
    path: "/license/activation",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationLicenseActivationDelete };
